export function orderRecords(rows,order,seed,lang,name=row=>row.name || '') {
  const rank=text=>{let h=2166136261;for(const ch of `${seed}:${text}`)h=Math.imul(h^ch.charCodeAt(0),16777619);return h>>>0;};
  const identity=row=>`${row.subject_id || ''}:${row.id}`;
  return [...rows].sort((a,b)=>{
    if(order==='name')return name(a).localeCompare(name(b),lang) || identity(a).localeCompare(identity(b));
    if(order==='recent')return String(b.created_at || '').localeCompare(String(a.created_at || '')) || identity(a).localeCompare(identity(b));
    return rank(identity(a))-rank(identity(b)) || identity(a).localeCompare(identity(b));
  });
}
